module.exports = __webpack_public_path__ + "img/partner_6.26284906.png";